import constate from 'constate'
import i18n from 'i18next'
import HttpBackend from 'i18next-http-backend'
import { useEffect, useState } from 'react'
import { initReactI18next } from 'react-i18next'

function useTranslations() {
  const [isTranslationLoading, setIsTranslationLoading] = useState(true)
  const [i18Instance, setI18Instance] = useState<typeof i18n>()
  const [currentLanguage, setCurrentLanguage] = useState<string>()

  const changeLanguage = async (lgn: string) => {
    setIsTranslationLoading(true)
    localStorage.setItem('language', lgn)
    setCurrentLanguage(currentLanguage)
    await i18Instance?.changeLanguage(lgn)
    setIsTranslationLoading(false)
  }
  i18n
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    .use(HttpBackend)
    .init({
      lng: currentLanguage,
      fallbackLng: 'en',
      returnEmptyString: false,
      backend: {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
      },
    })

  useEffect(() => {
    const currentLanguage = localStorage.getItem('language') || 'en'
    setCurrentLanguage(currentLanguage)
    setI18Instance(i18n)
  }, [])

  return { isTranslationLoading, changeLanguage, t: (i18n as unknown as typeof i18n).t }
}

const [TranslationsProvider, useTranslationContext] = constate(useTranslations)

export { TranslationsProvider, useTranslationContext }
